module.exports = __webpack_public_path__ + "img/a-middle-way-cover.629e5de6.jpg";